var _radialGradient, _radialGradient2, _radialGradient3, _radialGradient4, _radialGradient5, _radialGradient6, _radialGradient7, _radialGradient8, _radialGradient9, _radialGradient10, _radialGradient11, _radialGradient12, _radialGradient13, _radialGradient14, _radialGradient15, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUk49SLunch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 98 98",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 18.427,
    cy: 15.549,
    r: 33.118,
    gradientTransform: "matrix(.883 -.4694 .4226 .7949 -4.415 11.838)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.068,
    stopColor: "#d3fcff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.081,
    stopColor: "#cefaff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#c0f4fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.112,
    stopColor: "#a9ebfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#88defb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.146,
    stopColor: "#5ecdf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#37bdf6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185,
    stopColor: "#299ae4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.215,
    stopColor: "#1c77d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#1362c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.256,
    stopColor: "#105ac4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#0441ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#043071"
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 31.109,
    cy: 25.038,
    r: 44.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fafdfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.387,
    stopColor: "#ebf7fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.596,
    stopColor: "#d4eff9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#d1edfa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.909,
    stopColor: "#c8e7fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bcdefe"
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 26.526,
    cy: 16.951,
    r: 35.062,
    gradientTransform: "matrix(-.0443 .999 -2.1292 -.0945 63.794 -7.947)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fafdfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.387,
    stopColor: "#ebf7fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.596,
    stopColor: "#d4eff9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#d1edfa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.909,
    stopColor: "#c8e7fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bcdefe"
  }))), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 15.307,
    cy: 55.52,
    r: 6.061,
    gradientTransform: "matrix(-.0443 .999 -2.1292 -.0945 134.197 45.473)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fafdfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.387,
    stopColor: "#ebf7fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.596,
    stopColor: "#d4eff9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#d1edfa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.909,
    stopColor: "#c8e7fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bcdefe"
  }))), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 39.503,
    cy: 3.447,
    r: 22.05,
    fx: 39.282,
    fy: 3.298,
    gradientTransform: "matrix(-.0443 .999 -1.9266 -.0855 47.894 -35.723)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#faffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.112,
    stopColor: "#ebfdff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#d2fbff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253,
    stopColor: "#aff8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324,
    stopColor: "#85f4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.518,
    stopColor: "#dff2f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.735,
    stopColor: "#d4eff9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796,
    stopColor: "#d1eff9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.838,
    stopColor: "#c8f0fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#b9f1fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.908,
    stopColor: "#a3f2fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.939,
    stopColor: "#87f4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.941,
    stopColor: "#85f4ff"
  }))), _radialGradient6 || (_radialGradient6 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: 7.754,
    cy: 30.108,
    r: 9.383,
    fx: 3.197,
    fy: 38.31,
    gradientTransform: "matrix(-.9494 .3142 -.5405 -1.6335 31.39 76.85)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d4eff9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#ceebfa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.596,
    stopColor: "#c0e1fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bcdefe"
  }))), _radialGradient7 || (_radialGradient7 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: 49.077,
    cy: 38.093,
    r: 19.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#d5e8fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.228,
    stopColor: "#a9bed5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    stopColor: "#6f7b9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    stopColor: "#7784a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.819,
    stopColor: "#8e9cbb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.911,
    stopColor: "#b2c2dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "#d5e8fd"
  }))), _radialGradient8 || (_radialGradient8 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    cx: 42.526,
    cy: 28.592,
    r: 27.052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#d5e8fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.228,
    stopColor: "#a9bed5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    stopColor: "#6f7b9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    stopColor: "#7784a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.819,
    stopColor: "#8e9cbb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.911,
    stopColor: "#b2c2dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "#d5e8fd"
  }))), _radialGradient9 || (_radialGradient9 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "i",
    cx: 42.526,
    cy: 27.327,
    r: 27.052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e242e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1f1e2c"
  }))), _radialGradient10 || (_radialGradient10 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "j",
    cx: 42.527,
    cy: 27.328,
    r: 27.051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e242e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1f1e2c"
  }))), _radialGradient11 || (_radialGradient11 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "k",
    cx: 4.621,
    cy: 37.218,
    r: 8.788,
    gradientTransform: "matrix(.0242 -.9997 .826 .02 -26.234 41.093)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.014,
    stopColor: "#d5e8fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    stopColor: "#c2d6ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.229,
    stopColor: "#b0c4db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    stopColor: "#a9bed5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681,
    stopColor: "#abbfd6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    stopColor: "#adc1d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.778,
    stopColor: "#e5f1fe"
  }))), _radialGradient12 || (_radialGradient12 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "l",
    cx: 3.628,
    cy: 35.53,
    r: 5.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e242e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1f1e2c"
  }))), _radialGradient13 || (_radialGradient13 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "m",
    cx: 10.774,
    cy: -39.038,
    r: 5.637,
    gradientTransform: "matrix(1.0364 0 0 1.093 11.44 48.465)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#d5e8fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.228,
    stopColor: "#a9bed5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    stopColor: "#6f7b9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    stopColor: "#7784a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.819,
    stopColor: "#8e9cbb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.911,
    stopColor: "#b2c2dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "#d5e8fd"
  }))), _radialGradient14 || (_radialGradient14 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "n",
    cx: 22.352,
    cy: 5.441,
    r: 5.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e242e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1f1e2c"
  }))), _radialGradient15 || (_radialGradient15 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "o",
    cx: 32.083,
    cy: 1.092,
    r: 2.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e242e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1f1e2c"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.405 43.844s5.069-8.299 5.713-8.943 1.288-.94 2.136-.746 2.238 1.094 1.39 2.688-7.706 7.901-7.706 7.901l-1.533-.899zm2.586 17.447 1.39-4.078s3.955 1.543 5.529 1.492 3.669-.245 3.71-2.136c.051-1.891-1.216-2.381-3.71-3.128-2.504-.746-4.589-2.729-3.291-6.807 1.288-4.078 5.172-5.366 8.054-5.713s4.967.051 6.01.348 2.637 1.145 2.637 1.145l-1.84 4.221s-3.823-1.942-6.367-1.288c-2.535.644-3.281 2.831-1.594 3.649s4.221 1.421 5.662 2.954c1.329 1.421 1.482 5.325-1.288 8.054-2.719 2.678-7.89 3.925-14.902 1.288z",
    fill: "#24272f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.504 48.719c0 18.663-15.188 33.789-33.912 33.789S2.68 67.382 2.68 48.719 17.868 14.93 36.592 14.93s33.912 15.137 33.912 33.789z",
    fill: "url(#a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.992 32.018c-11.836-1.952-33.064-1.748-42.273-.889-4.098 4.967-6.582 11.406-6.582 18.458 0 6.725 2.269 12.898 6.03 17.763 11.57 1.278 38.787.705 43.356-.93a28.96 28.96 0 0 0 5.356-16.833c-.01-6.643-2.218-12.735-5.887-17.569z",
    fill: "url(#b)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.109 30.945C60.028 21.338 49.296 14.94 37.042 14.94c-18.98 0-34.362 15.31-34.362 34.188s15.249 33.943 32.001 33.943c.531 0 3.23-.174 4.078-.623-1.738.276-3.444.041-4.027-.123-6.848-1.952-4.824-2.831-5.519-3.434-.695-.593-4.569-1.891-8.35-3.577s-9.74-5.366-10.343-6.265c-.593-.899-4.374-7.952-4.374-7.952h3.577s.194-2.085 0-4.875c-.194-2.78.399-16.108.399-18.591s-.593-1.993-1.288-1.789c-.695.194-2.249.531-2.249.531s.654-1.594 1.584-3.189 2.381-3.71 2.381-3.71 2.913.266 6.49-.664 7.819-1.462 8.616-2.647c.797-1.196 2.381-3.976 6.623-6.756s9.751-4.109 16.701-1.063 12.193 10.742 13.246 11.008.276.399 3.455 3.444c.726.695 1.513 2.136 2.31 3.915-.807-2.422-1.901-4.937-1.881-5.764z",
    fill: "url(#c)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.054 71.634c2.187 1.288 9.239 5.366 12.725 5.713-1.462-.583-3.189-1.257-4.916-2.034-3.782-1.686-9.74-5.366-10.343-6.265 0 0 .348 1.288 2.535 2.586z",
    fill: "url(#d)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.181 32.519c-.583-.767-2.218-1.523-2.525-2.78s-.94-.215-1.421-.93-2.76-3.25-8.258-7.952-11.723-5.529-18.632-3.577-9.403 7.757-9.934 8.483-3.976 1.462-8.33 2.32-6.378.859-6.378.859-1.993 2.453-2.719 3.782-1.84 3.812-1.84 3.812l.429-.164s.664-1.594 1.594-3.179 2.381-3.71 2.381-3.71 2.913.266 6.49-.664 7.819-1.462 8.616-2.647c.797-1.196 2.381-3.976 6.623-6.756s9.751-4.109 16.701-1.063 12.193 10.742 13.246 11.008.276.399 3.455 3.444c.726.695 1.513 2.136 2.31 3.915l-1.318-3.618-.491-.583z",
    fill: "url(#e)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.722 56.221c-.194-2.78.399-16.108.399-18.591 0-1.41-.194-1.84-.491-1.932.02.664.041 1.605.041 2.964-.01 2.944-.593 22.434-.593 22.434h.644c0-.01.204-2.095 0-4.875z",
    fill: "url(#f)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.476 82.12c-6.878-1.86-4.579-2.637-5.274-3.23a2.41 2.41 0 0 0-.47-.286l-.072.767c-.102 1.37.899 2.013 3.577 3.005.736.276 2.208.439 3.955.552.879-.123 2.075-.235 2.555-.48-.685-.153-2.034.276-4.272-.327z",
    fill: "#7192ce"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M63.329 40.266c-1.635-3.475-5.018-6.562-10.343-5.519-5.315 1.043-6.459 9.147-6.265 11.038s.797 7.655 6.459 9.096 7.809-3.281 7.809-3.281.051 2.341-.746 4.773-1.492 4.528-4.272 4.62c-2.78.102-3.434-3.526-3.434-3.526h-5.366c.051 2.688 1.543 7.502 7.655 7.706 6.112.194 9.045-6.316 9.894-10.742s.245-10.691-1.39-14.166zM58.311 50.2c-2.453 1.134-4.875-.102-5.713-4.129-.848-4.027 1.441-5.969 1.441-5.969.899-.848 4.773-1.39 5.897 2.33 1.114 3.72.644 6.725-1.625 7.768z",
    fill: "url(#g)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M45.862 53.829h-4.017l-.01-5.918c-.245-9.597-.644-12.479-.644-12.479h-5.713L21.905 53.185v5.57l13.88.143c-.112 2.616-.296 5.039-.603 6.96H41.1s.327-2.749.562-6.899l4.211.041v-5.172zm-18.755 0v-.501l8.667-10.507a267.536 267.536 0 0 1 .133 11.008h-8.8z",
    fill: "url(#h)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M45.862 52.541h-4.017l-.01-5.918c-.245-9.597-.644-12.479-.644-12.479h-5.713L21.905 51.898v5.57l13.88.143c-.112 2.616-.296 5.039-.603 6.96H41.1s.327-2.749.562-6.899l4.211.041v-5.172zm-18.755 0v-.501l8.667-10.507a267.536 267.536 0 0 1 .133 11.008h-8.8z",
    fill: "url(#i)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M64.055 39.663c-1.635-3.475-5.018-6.562-10.343-5.519-5.315 1.043-6.459 9.147-6.265 11.038s.797 7.655 6.459 9.096 7.809-3.281 7.809-3.281.051 2.341-.746 4.773-1.492 4.528-4.272 4.62c-2.78.102-3.434-3.526-3.434-3.526h-5.366c.051 2.688 1.543 7.502 7.655 7.706s9.045-6.316 9.894-10.742.256-10.681-1.39-14.166zm-5.018 9.945c-2.453 1.134-4.875-.102-5.713-4.129-.848-4.027 1.441-5.969 1.441-5.969.899-.848 4.773-1.39 5.897 2.33 1.114 3.72.644 6.725-1.625 7.768z",
    fill: "url(#j)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m4.469 47.37 1.032-.501s-.296.45-.695 2.249c-.256 1.155-.675 7.267-.736 9.536h1.328s.051-.848-.102-4.62c-.143-3.782 1.594-7.41 1.594-7.41l.245-3.976-3.005 1.155c-.164 1.053-1.278 2.116-1.339 3.199l1.676.368z",
    fill: "url(#k)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m4.305 46.378.194.501s-.296.45-.695 2.249c-.256 1.155-.388 4.497-.45 6.766l.705 2.77h.337s.051-.848-.102-4.62c-.153-3.782 1.594-7.41 1.594-7.41l.245-3.976-3.005 1.155-.348 3.199 1.523-.634z",
    fill: "url(#l)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M19.677 24.537s1.134-1.738 2.933-3.424l2.831-2.443 3.557.327 1.237-.981 1.032-.756H28.18l1.339-.756-.358-.511a34.552 34.552 0 0 0-8.371 3.373l2.034-.266-2.882 2.821h-.46l-.603-1.339-2.422 1.748.91 2.197h2.31z",
    fill: "url(#m)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M19.565 23.811s1.094-1.594 2.831-3.128l2.739-2.238 3.434.296 1.196-.899.991-.695h-2.984l1.288-.695-.348-.46c-2.841.705-5.56 1.727-8.074 3.087l1.962-.235-2.78 2.586h-.45l-.583-1.226-2.33 1.605.879 2.013h2.228z",
    fill: "url(#n)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M37.134 14.94h-.092c-2.422 0-4.793.256-7.073.736.307.143.726.256 1.329.286 1.809.092 4.64-.296 5.836-1.022z",
    fill: "url(#o)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M17.081 76.907c2.984 2.126 6.316 3.812 9.904 4.896a116.554 116.554 0 0 0-5.09-2.729 72.178 72.178 0 0 0-4.814-2.167z",
    fill: "#24272f"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m65.721 33.071 2.289 3.628c.746 1.288 1.186 2.708 1.186 2.708s-.92-3.966-2.443-6.112c-.951-1.339-2.453-2.484-2.719-2.79s-.675-.235-.675-.235l2.361 2.8z",
    fill: "#7192ce"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUk49SLunch);
export default __webpack_public_path__ + "static/media/uk_49s_lunch.3b20622f773ebc0f83874b205226baa9.svg";
export { ForwardRef as ReactComponent };